'use strict';
import * as $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse from "./app.data.-Drug-Request-Pharmacy-Response.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrugRequestPharmacyResponse$$anon$10(\u03b4name$2, _$ordinal$2) {
  this.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f_$name$1 = null;
  this.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f__$ordinal$1 = 0;
  this.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f_$name$1 = \u03b4name$2;
  this.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lapp_data_DrugRequestPharmacyResponse$$anon$10 as $c_Lapp_data_DrugRequestPharmacyResponse$$anon$10 };
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype = new $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse.$h_Lapp_data_DrugRequestPharmacyResponse();
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.constructor = $c_Lapp_data_DrugRequestPharmacyResponse$$anon$10;
/** @constructor */
function $h_Lapp_data_DrugRequestPharmacyResponse$$anon$10() {
}
export { $h_Lapp_data_DrugRequestPharmacyResponse$$anon$10 as $h_Lapp_data_DrugRequestPharmacyResponse$$anon$10 };
$h_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype = $c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype;
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.productPrefix__T = (function() {
  return this.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f_$name$1;
});
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.toString__T = (function() {
  return this.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f_$name$1;
});
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lapp_data_DrugRequestPharmacyResponse$$anon$10__f_$name$1);
});
$c_Lapp_data_DrugRequestPharmacyResponse$$anon$10.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_data_DrugRequestPharmacyResponse$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrugRequestPharmacyResponse$$anon$10, "app.data.DrugRequestPharmacyResponse$$anon$10", ({
  Lapp_data_DrugRequestPharmacyResponse$$anon$10: 1,
  Lapp_data_DrugRequestPharmacyResponse: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_data_DrugRequestPharmacyResponse$$anon$10 as $d_Lapp_data_DrugRequestPharmacyResponse$$anon$10 };
//# sourceMappingURL=app.data.-Drug-Request-Pharmacy-Response$$anon$10.js.map
